import { FileText } from "lucide-react";

export default function CitationCard({ citation, index, testId, onClick }) {
  const path = (citation.section_path || []).join(" › ");
  const clickable = typeof onClick === "function";
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } } : undefined}
      className={`rounded-xl border border-border bg-secondary/40 p-3 text-sm transition-colors hover:bg-secondary ${clickable ? "cursor-pointer hover:border-foreground/30" : ""}`}
    >
      <div className="flex items-start gap-2.5">
        <div className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-foreground text-[11px] font-semibold text-background mono">
          {citation.n ?? index + 1}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-1.5 font-medium text-foreground">
            <FileText className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
            <span className="truncate">{citation.document || "Doküman"}</span>
          </div>
          {path && <div className="mt-0.5 truncate text-xs text-muted-foreground">{path}</div>}
          <div className="mt-1.5 flex items-center gap-2 text-xs text-muted-foreground">
            {citation.page != null && <span>Sayfa {citation.page}</span>}
            {citation.score != null && (
              <span className="mono rounded bg-background px-1.5 py-0.5 text-[10px]">
                skor {Number(citation.score).toFixed(2)}
              </span>
            )}
          </div>
          {citation.snippet && (
            <p className="mt-2 line-clamp-3 border-l-2 border-border pl-2.5 text-xs italic text-muted-foreground">
              {citation.snippet}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
